var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"marketing-automation-form"},[(!_vm.hasLoaded)?_c('loading',{staticClass:"marketing-automation-form-loading"}):_c('marketing-automation-form-steps',{attrs:{"initial-steps":_vm.steps,"automation-id":_vm.automation.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }